<template>
  <div>
    <v-container class="py-10">
      <v-row class="align-center">
        <v-col cols="12" lg="6" class="pr-10">
          <h2>15. Potenzial von Zukunftstechnologien - "Deep Dive" 1</h2>
          <p></p>
        </v-col>
        <v-col cols="12" lg="6">
          <highcharts :options="chartOptions" ref="chart"></highcharts>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "FutureTechBySector",
  computed: {
    chartOptions() {
      return {
        chart: {
          type: "bar"
        },
        title: {
          text: "Großes bis sehr großes Potenzial (%) nach Tätigkeitsbereich"
        },
        xAxis: {
          categories: [
            "Blockchain",
            "Künstliche Intelligenz",
            "Chatroboter",
            "3D-Druck",
            "Internet of Things (IoT)",
            "Cloud-Computing",
            "Virtual Reality (VR) / Augmented Reality (AR)"
          ],
          crosshair: true
        },
        colors: ["#546825", "#005a85", "#9d0c4a"],
        yAxis: {
          min: 0,
          title: {
            text: "Prozent der Organisationen"
          }
        },
        tooltip: {
          headerFormat:
            '<span style="font-size:10px">{point.key}</span><table>',
          pointFormat:
            '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
            '<td style="padding:0"><b>{point.y:.1f}%</b></td></tr>',
          footerFormat: "</table>",
          shared: true,
          useHTML: true
        },
        plotOptions: {
          column: {
            pointPadding: 0.2,
            borderWidth: 0
          }
        },
        series: [
          {
            name: "Freizeit und Geselligkeit",
            data: [5.5, 5.7, 1.4, 12.2, 6.5, 3.6, 8.7]
          },
          {
            name: "Wirtschafts- und Berufsverbände",
            data: [0, 10, 20, 8.3, 3.6, 70, 20]
          },
          {
            name: "Wissenschaft und Forschung",
            data: [2.8, 35.7, 8.3, 29.2, 28.4, 54.2, 37.6]
          }
        ]
      };
    }
  },
  methods: {
    downloadJPEG() {
      this.$refs.chart.chart.exportChart({ type: "image/jpeg" });
    },
    downloadSVG() {
      this.$refs.chart.chart.exportChart({ type: "image/svg+xml" });
    },
    downloadPDF() {
      this.$refs.chart.chart.exportChart({ type: "application/pdf" });
    },
    downloadCSV() {
      this.$refs.chart.chart.downloadCSV();
    }
  }
};
</script>

<style scoped>
.chapter-color {
  background-color: #fff;
  min-height: 20em;
}
.component-color {
  background-color: #fff;
}
</style>
